import React from "react";
import { Link } from "react-router-dom";
import Navbar2 from "../Navbar2";
import rightImage from "../../assets/img/content/Home-hero_md.png";
import pizza from "../../assets/img/content/la-pinoz-pizza.png";
import starbiryani from "../../assets/img/content/Star-Biryani-Logo.png";
import jumboking from "../../assets/img/content/jumbo-king.png";
import Hocco from "../../assets/img/content/Hocco.png";
import yamyamcha from "../../assets/img/content/yam-yam-cha.png";
import tgifriday from "../../assets/img/content/tgi-friday.png";
import gianis from "../../assets/img/content/gianis.png";
import yangkiez from "../../assets/img/content/yangkiez.png";
import kabhib from "../../assets/img/content/kabhib.png";
import apsara from "../../assets/img/content/apsara.png";
import bercos from "../../assets/img/content/bercos.png";
import kailashparbat from "../../assets/img/content/kailash-parbat.png";
import billing from "../../assets/img/content/billing-software_lg.png";
import crm from "../../assets/img/content/crm.png";
import analytics from "../../assets/img/content/analytics.png";
import customerService from "../../assets/img/content/Customer-service.png";
import operations from "../../assets/img/content/Operations.png";
import multiple from "../../assets/img/content/Multiple-integrations.png";
import multipledsktp from "../../assets/img/content/multiple_integration_dsktp.png";
import outlet1 from "../../assets/img/content/Outlet-Types-Icons-1.png";
import outlet2 from "../../assets/img/content/Outlet-Types-Icons-2.png";
import outlet3 from "../../assets/img/content/Outlet-Types-Icons-3.png";
import outlet4 from "../../assets/img/content/Outlet-Types-Icons-4.png";
import outlet5 from "../../assets/img/content/Outlet-Types-Icons-5.png";
import outlet6 from "../../assets/img/content/Outlet-Types-Icons-6.png";
import outlet7 from "../../assets/img/content/Outlet-Types-Icons-7.png";
import outlet8 from "../../assets/img/content/Outlet-Types-Icons-8.png";
import outlet9 from "../../assets/img/content/Outlet-Types-Icons-9.png";
import outlet10 from "../../assets/img/content/Outlet-Types-Icons-10.png";
import happyCustomers from "../../assets/img/content/Happy-customers.png";
import bills from "../../assets/img/content/Bills-processed-everyday.png";
import errors from "../../assets/img/content/Processing-errors.png";
import rating1 from "../../assets/img/content/capterra-ratings.png";
import rating2 from "../../assets/img/content/software-suggest-ratings.png";
import rating3 from "../../assets/img/content/google-ratings.png";

function MenuMitra() {
  return (
    <div>
      <Navbar2 />
      <section className="pt-6">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 text-start">
              <h1 className="my-0" style={{ fontSize: "3.5rem" }}>
                Restaurant POS
              </h1>
              <h1 className="my-0" style={{ fontSize: "3.5rem" }}>
                software made
              </h1>
              <h1 className="my-0" style={{ fontSize: "3.5rem" }}>
                simple!
              </h1>
              <div className="section-heading title-style5 left half mt-2 ">
                <h5 className="">
                  <strong>
                    Manages all your restaurant operations efficiently so that
                    you can focus on growing your brand, like a real boss!
                  </strong>
                </h5>
              </div>
            </div>
            <div className="col-lg-6 text-center ">
              <div className="about-ceo ms-lg-5">
                <img
                  src={rightImage}
                  alt="Company Affiliations"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="p-4">
        <div className="text-center mb-3">
          <h3>
            Trusted by <span className="fw-bold">75,000+ restaurants</span>
          </h3>
        </div>

        <div className="container mt-2">
          <div className="row text-center">
            <div className="col-lg-2 col-md-4 my-2  col-6">
              <div className="">
                <img
                  src={pizza}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2  col-6">
              <div className="">
                <img
                  src={starbiryani}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2 col-6">
              <div className="">
                <img
                  src={jumboking}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 mt-4 pt-2 col-6">
              <div className="">
                <img
                  src={Hocco}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "64px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2 col-6">
              <div className="">
                <img
                  src={yamyamcha}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2 col-6">
              <div className="">
                <img
                  src={tgifriday}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
          </div>

          <div className="row text-center">
            <div className="col-lg-2 col-md-4 my-2 col-6">
              <div className="">
                <img
                  src={gianis}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2 col-6 ">
              <div className="">
                <img
                  src={yangkiez}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2 col-6">
              <div className="">
                <img
                  src={kabhib}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 mt-4 pt-2 col-6">
              <div className="">
                <img
                  src={apsara}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "64px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2 col-6">
              <div className="">
                <img
                  src={bercos}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-4 my-2 col-6">
              <div className="">
                <img
                  src={kailashparbat}
                  alt="Android"
                  className="me-2"
                  style={{ width: "118px", height: "118px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="">
        <div className="container">
          <h6 className="text-uppercase text-primary">smart pos features</h6>
          <h2>A restaurant POS made for all your needs</h2>
          <h6>
            A quick and easy-to-use restaurant billing software that makes
            managing high order volumes butter smooth
          </h6>
        </div>
        <div className="container">
          <div className="row my-6">
            <div className="col-lg-6 text-center ">
              <img
                src={billing}
                alt=""
                className="img-fluid"
                style={{ width: "450px", height: "350px" }}
              />
            </div>
            <div className="col-lg-6 pt-3 pt-md-5 ">
              <h3>
                <span className="text-primary">Billing</span> Software
              </h3>
              <p>
                Take orders, punch bills and generate KOT. Accept payments
                either by splitting bill or merging tables. Easily apply
                discounts and coupons. All of this, and more, is easy and quick
                with Menu Mitra restaurant POS.
              </p>
              <Link to="https://menumitra.com/" className="" target="_blank">
                Explore all features <i className="fa fa-arrow-right"></i>
              </Link>
            </div>
          </div>

          <div className="row my-6 ">
            <div className="col-lg-6 text-center p-2">
              <img
                src={billing}
                alt=""
                className="img-fluid "
                style={{ width: "450px", height: "350px" }}
              />
            </div>
            <div className="col-lg-6 pt-lg-5 pt-3 pt-md-8">
              <h3>
                Get real-time restaurant{" "}
                <span className="text-primary">Reports</span>
              </h3>
              <p>
                Automate your restaurant reports and go paper free! Let Menu
                Mitra POS automatically track your business activities and
                provide you error free reports on your restaurant’s day-end
                sales, online orders, staff actions, inventory consumption, and
                various 80+ essential business reports
              </p>
              <Link to="https://menumitra.com/" className="" target="_blank">
                Explore all features <i className="fa fa-arrow-right"></i>
              </Link>
            </div>
          </div>
          <div className="row my-6">
            <div className="col-lg-6 text-center">
              <img
                src={billing}
                alt=""
                className="img-fluid"
                style={{ width: "450px", height: "350px" }}
              />
            </div>
            <div className="col-lg-6 pt-3 pt-md-5">
              <h3>
                A single{" "}
                <span className="text-primary">Online Ordering System</span> to
                manage all your orders
              </h3>
              <p>
                Accept online orders, manage online menu, mark food ready,
                collect payment and check revenue without shuffling between
                multiple screens
              </p>
              <Link to="https://menumitra.com/" className="" target="_blank">
                Explore all features <i className="fa fa-arrow-right"></i>
              </Link>
            </div>
          </div>
          <div className="row my-6">
            <div className="col-lg-6 text-center">
              <img
                src={billing}
                alt=""
                className="img-fluid"
                style={{ width: "450px", height: "350px" }}
              />
            </div>
            <div className="col-lg-6 pt-3 pt-md-5">
              <h3>
                A single Restaurant
                <span className="text-primary"> Inventory</span> management made
                easier
              </h3>
              <p>
                Do inventory management the smart way. Put your inventory on the
                item-wise auto deduction, get low-stock alters, day-end
                inventory reports and more with Petpooja restaurant POS
              </p>
              <Link to="https://menumitra.com/" className="" target="_blank">
                Explore all features <i className="fa fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="p-4 bg-light-gray">
        <div className="container">
          <h6 className="">APP MARKETPLACE</h6>
          <h2 className="fw-bold">
            Add-ons to supercharge your Restaurant POS
          </h2>
        </div>

        <div className="container mt-5">
          <div className="container-fluid px-lg-0">
            <div className="horizontaltab tab-style5">
              <ul className="resp-tabs-list hor_1 ">
                <li className="">CRM</li>
                <li>Analytics</li>
                <li>Customer service</li>
                <li>Operations</li>
              </ul>
              <div className="resp-tabs-container hor_1 p-0">
                <div>
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-lg-6 mb-4 mb-lg-0 text-center text-lg-start">
                        <div className="box-shadow-large p-2">
                          <img src={crm} alt="..." className="img-fluid rounded" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="ps-lg-1-9">
                          <p>
                            Bill payment is not the end of the service. That's
                            why we’ve built smart CRM tools that help you know
                            your customers well and deliver the best to win
                            their trust and loyalty
                          </p>
                          <Link to="https://menumitra.com/" className="" target="_blank">learn more</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-lg-6 order-lg-1 order-2">
                        <div className="pe-lg-1-9">
                          <p>
                            Know your business to grow your business with
                            insightful 100+ downloadable reports about your
                            sales, inventory, cancelled orders, payments, CRM,
                            and much more
                          </p>
                          <Link to="https://menumitra.com/" className="" target="_blank">learn more</Link>
                        </div>
                      </div>
                      <div className="col-lg-6 order-lg-2 order-1 text-center text-lg-start mb-4 mb-lg-0">
                        <div className="box-shadow-large p-2">
                          <img src={analytics} alt="..."  className="img-fluid rounded" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-lg-6 mb-4 mb-lg-0 text-center text-lg-start">
                        <div className="box-shadow-large p-2">
                          <img src={customerService} alt="..."  className="img-fluid rounded" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="ps-lg-1-9">
                          <p>
                            Use smart and easy-to-use technology that helps you
                            offer premium service and the best hospitality to
                            make your customers' experiences memorable
                          </p>
                          <Link to="https://menumitra.com/" className="" target="_blank">learn more</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-lg-6 order-lg-1 order-2">
                        <div className="pe-lg-1-9">
                          <p>
                            Menu Mitra POS features that are built to simplify
                            your staff's everyday operations, be it inside the
                            kitchen or in the dining area or behind the billing
                            counter, hassle-free
                          </p>
                          <Link to="https://menumitra.com/" className="" target="_blank">learn more</Link>
                        </div>
                      </div>
                      <div className="col-lg-6 order-lg-2 order-1 text-center text-lg-start mb-4 mb-lg-0">
                        <div className="box-shadow-large p-2">
                          <img src={operations} alt="..."  className="img-fluid rounded" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-6">
      <div className="container">
  <div className="row align-items-center">
    <div className="col-lg-6 col-md-6 text-center text-lg-start order-2 order-md-1">
      <h6 className="text-uppercase">integrations</h6>
      <div className="section-heading title-style5 left half mt-0 ">
        <h4 className="">Multiple integrations - single dashboard</h4>
        <p>
          Manage 150+ third-party integrations and services directly from
          <br /> Menu Mitra POS
        </p>
      </div>
      <Link to="https://menumitra.com/"  target="_blank" className="text-start me-md-20">
        See all integrations <i className="fa fa-arrow-right"></i>
      </Link>
    </div>
    <div className="col-lg-6 col-md-6 text-center order-1 order-md-2">
      <div className="about-ceo ms-lg-5">
        <img
          src={multiple}
          alt="Company Affiliations"
          className=""
        />
      </div>
    </div>
  </div>
</div>

        <div className="container p-4">
          <Link to="https://menumitra.com/" target="_blank">
            {" "}
            <img src={multipledsktp} alt="" className="img-fluid rounded" />
          </Link>
        </div>
      </section>
      <div className="container-fluid bg-light-gray pt-5">
        <div className="row">
          <div className="col">
            <p className="text-uppercase text-center fw-bold m-0">
              outlet types
            </p>
            <h2 className="text-center">
              Built for all types of food business
            </h2>
            <div className="text-center mt-2">
              The all-in-one Restaurant Management System for all types of
              restaurant formats and food outlets
            </div>
          </div>
        </div>
        <div className="container p-lg-5 p-md-5">
  <div className="row justify-content-between">
    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          borderRadius: "10px", 
          padding: "10px",
        }}
      >
        <img
          src={outlet1}
          alt="Food courts & canteens"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Food courts &amp; canteens</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet2}
          alt="Cafe"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Cafe</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center "
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd ",
          borderRadius: "10px", 
          padding: "10px",
        }}
      >
        <img
          src={outlet3}
          alt="Fine dine"
          className="img-fluid "
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Fine dine</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet4}
          alt="Bar & brewery"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Bar &amp; brewery</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet5}
          alt="Pizzeria"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Pizzeria</h5>
      </div>
    </div>
  </div>

  <div className="row justify-content-between">
    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet6}
          alt="QSR"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">QSR</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet7}
          alt="Desserts"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Desserts</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet8}
          alt="Large chains"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Large chains</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet9}
          alt="Bakery"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Bakery</h5>
      </div>
    </div>

    <div className="col-lg-2 col-md-4 col-6 my-2">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "170px",
          border: "2px solid #ddd",
          padding: "10px",
          borderRadius: "10px", 
        }}
      >
        <img
          src={outlet10}
          alt="Cloud kitchens"
          className="img-fluid"
          style={{ maxWidth: "80px", maxHeight: "80px" }}
        />
        <h5 className="text-center mt-2">Cloud kitchens</h5>
      </div>
    </div>
  </div>
</div>

      </div>

     

      <div className="container mt-4 mb-4">
  <div className="text-center position-relative">
    <div className="d-flex flex-wrap justify-content-center align-items-start align-items-lg-center  flex-column flex-md-row">
      <div className="d-flex align-items-center align-items-start align-items-lg-end mx-3 my-2">
        <img
          src={happyCustomers}
          alt=""
          className="img-fluid"
          style={{ width: "80px", height: "80px" }}
        />
        <span className="text-start ms-3">
          <span className="text-primary fs-4">75K + </span>
          <br />
          <span>Happy customers</span>
        </span>
      </div>

      <div className="d-flex align-items-start align-items-lg-center mx-3 my-2">
        <img
          src={bills}
          alt=""
          className="img-fluid"
          style={{ width: "80px", height: "80px" }}
        />
        <span className="text-start ms-3">
          <span className="text-primary fs-4">60L</span>
          <br />
          <span>Bills processed every day</span>
        </span>
      </div>

      <div className="d-flex align-items-start align-items-lg-center mx-3 my-2">
        <img
          src={errors}
          alt=""
          className="img-fluid"
          style={{ width: "80px", height: "80px" }}
        />
        <span className="text-start ms-3">
          <span className="text-primary fs-4">0%</span>
          <br />
          <span>Processing errors</span>
        </span>
      </div>
    </div>
  </div>
</div>


     
        <div className="container text-center my-6">
          <h4 className="text-dark fw-bolder ">industry ratings</h4>
          <div className="row justify-content-between p-4">
            <div className="col-lg-4 col-md-4 my-2 d-sm-block">
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                
              >
                <img
                  src={rating1}
                  alt="Food courts & canteens"
                  className="img-fluid"
                  style={{ width: "255px", height: "171px" }}
                />
                <h6 className="text-center mt-2">Reviews voted us as the value-for-money billing solution</h6>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 my-2 d-sm-block">
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                
              >
                <img
                  src={rating2}
                  alt="Food courts & canteens"
                  className="img-fluid"
                  style={{ width: "255px", height: "171px" }}
                />
                <h6 className="text-center mt-2">Rated as the most user-friendly restaurant POS

</h6>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 my-2 d-sm-block">
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                
              >
                <img
                  src={rating3}
                  alt="Food courts & canteens"
                  className="img-fluid"
                  style={{ width: "255px", height: "171px" }}
                />
                <h6 className="text-center mt-2">Restaurateurs rated us the most recommended POS provider

</h6>
              </div>
            </div>

            

           
          </div>
        </div>
      
    </div>
  );
}

export default MenuMitra;
